import React from 'react'
import Layout from '../../common/Layout'
import ResetPasswordContainer from '../../features/ResetPassword/ResetPasswordContainer'

export default {
  path: '/reset-password/:resetToken',
  async action ({ params }) {
    const resetToken = params.resetToken
    return {
      title: 'Reset Password',
      component: <Layout containerWell ><ResetPasswordContainer resetToken={resetToken} /></Layout>
    }
  }

}
